<section class="container-capped px-0 py-2">
  <div class="d-flex flex-wrap py-1">
    <ng-container *ngIf="!inline">
      <div class="d-flex flex-wrap align-item-center">
        <div class="ml-1">
          <input type="search" name="keyword" [ngModel]="criteria.Keyword" placeholder="جستجو"
            (debounce)="navigate('q',$event.target.value||undefined)">
        </div>
        <!-- <div class="ml-1">
          <select [ngModel]="criteria.Type" (ngModelChange)="navigate('type',$event)">
            <option [ngValue]="undefined">همه فعالیت‌‍ها</option>
            <option [ngValue]="ActivityType.prepare_tasks">برنامه‌ریزی تسک‌ها</option>
            <option [ngValue]="ActivityType.verify_ads">تایید آگهی</option>
            <option [ngValue]="ActivityType.vanguard_seeker">کارجوی پیشتاز</option>
            <option [ngValue]="ActivityType.buy_resume">خرید رزومه</option>
            <option [ngValue]="ActivityType.control_report">گزارش تخلف</option>
            <option [ngValue]="ActivityType.sms">ارسال پیامک</option>
            <option [ngValue]="ActivityType.email">ارسال ایمیل</option>
            <option [ngValue]="ActivityType.push">پوش نوتیفیکیشن</option>
            <option [ngValue]="ActivityType.instagram_post">پست اینستاگرام</option>
            <option [ngValue]="ActivityType.instagram_story">استوری اینستاگرام</option>
            <option [ngValue]="ActivityType.telegram_post">پست تلگرام</option>
            <option [ngValue]="ActivityType.telegram_group">تلگرام گروهی</option>
            <option [ngValue]="ActivityType.reportage">رپورتاژ</option>
            <option [ngValue]="ActivityType.linkedin">لینکداین</option>
            <option [ngValue]="ActivityType.twitter">توییتر</option>
            <option [ngValue]="ActivityType.note">یادداشت</option>
            <option [ngValue]="ActivityType.task">وظیفه</option>
            <option [ngValue]="ActivityType.employer_nps">بازخورد کارفرما</option>

          </select>
        </div> -->
        <div class="ml-1">
          <select [ngModel]="criteria.OperatorId" (ngModelChange)="navigate('opid',$event)">
            <option value="00000000-0000-0000-0000-000000000000">همه کاربران</option>
            <option *ngFor="let item of operators" [ngValue]="item.Id">{{item.Name || item.Username}}</option>
          </select>
        </div>
        <label class="mx-1 mb-0 d-flex align-items-center">
          <input type="checkbox" name="all" [ngModel]="criteria.IsDone==undefined"
            (ngModelChange)="navigate('all',$event||undefined)">
          <span>نمایش همه</span>
        </label>
        <label class="mx-1 mb-0 d-flex align-items-center">
          <input type="checkbox" name="future" [ngModel]="criteria.ToDate?.getTime()!=now.getTime()"
            (ngModelChange)="navigate('future',$event||undefined)">
          <span>آینده</span>
        </label>
        <div class="mr-auto fs-xs">
          <a href="/api/activity/ical/{{operator.Id}}/tasks">iCal</a>
        </div>
      </div>
      <div class="d-flex align-items-center flex-fill">
        <app-pagination class="mx-auto" [total]="total" [limit]="limit"></app-pagination>
      </div>
    </ng-container>

    <div class="d-flex flex-wrap align-items-center justify-content-end w-100 mb-1">
      <ng-container *ngIf="showAdd">
        <button class="btn btn-sm btn-secondary m-1 fs-sm" *ngIf="user" (click)="newActivity(true)" type="button">ثبت یادداشت</button>
        <button class="btn btn-sm btn-secondary m-1 fs-sm" (click)="newActivity(false)" type="button">ثبت وظیفه</button>
      </ng-container>
      <ng-content select="[buttons]"></ng-content>
    </div>
  </div>

</section>
<div class="container-capped px-0">
  <div *ngFor="let activity of activities">
    <div class="border-bottom p-1 mb-1 lh-xs w-100 kp-toolbar-container">
      <div class="d-flex align-items-center ">
				<!-- <pre>{{ activity.ReadyToWorkAd | json }}</pre> -->
        <div class="ml-auto fs-sm">
          {{activity.Operator?.name}}
          <span class="mr-1 f-gray fs-sm" *ngIf="activity.Creator && activity.OperatorId!=activity.CreatorId">
            <ng-container *ngIf="activity.Operator"> از </ng-container>
            {{activity.Creator?.name}}
          </span>
        </div>

        <div class="d-flex align-items-center" *ngIf="activity.User">
          <a *ngIf="operator.IsOperator" target="_blank" class="btn btn-link btn-sm fs-xs f-blue px-1 mx-1" [routerLink]="['/admin/user']"
            [queryParams]="{q:activity.UserId}"><i class="fa fa-cog ml-1"></i>{{activity.User.Name ||
            activity.User.name || 'بدون نام'}}</a>
          <a class="btn btn-link btn-sm fs-xs f-blue px-1 mx-1" *ngIf="activity.UserSummary?.seeker"
            [routerLink]="['/karpasha/pipeline/seeker', activity.UserId]"><i class="fa fa-user ml-1"></i>کاریز کارجو</a>
          <a class="btn btn-link btn-sm fs-xs f-blue px-1 mx-1" *ngIf="activity.UserSummary?.employer"
            [routerLink]="['/karpasha/pipeline/job', (activity.JobId && activity.JobId!= Guid.Empty) ? activity.JobId : activity.UserId]"><i
              class="fa fa-user ml-1"></i>کاریز کارفرما</a>
        </div>
        <div class="d-flex align-items-center" *ngIf="activity.Job">
          <a target="_blank" class="btn btn-link btn-sm fs-xs f-blue px-1 mx-1"
            [routerLink]="['/admin/ads', {job:activity.JobId}]" [queryParams]="{q:activity.JobId}"><i
              class="fa fa-bullhorn ml-1"></i>
            {{activity.Job.Title || activity.Job.title || activity.Job.Code || 'بدون عنوان'}}
          </a>
        </div>
        <div class="d-flex align-items-center" *ngIf="activity.ReadyToWorkAd">
          <a target="_blank" class="btn btn-link btn-sm fs-xs f-blue px-1 mx-1"
            [routerLink]="['/admin/rtwad', {id:activity.ReadyToWorkAdId}]" ><i
              class="fa fa-bullhorn ml-1"></i>
            {{activity.ReadyToWorkAd.title || 'آگهی آماده به کار بدون عنوان'}}
          </a>
        </div>

      </div>
      <div class="d-flex align-items-center">
        <i class="fa fa-square {{!activity.IsDone && activity.IsOverdue ? 'f-red' : 'f-blue'}} pointer"
          (click)="openDone(activity)" *ngIf="!activity.IsDone && activity.OperatorId == operator.Id"></i>
        <i class="fa fa-square f-light-gray" *ngIf="!activity.IsDone && activity.OperatorId != operator.Id"></i>
        <i class="fa fa-check-square f-gray" *ngIf="activity.IsDone && activity.Note"></i>
        <div class="flex-fill mx-1 fs-sm no-wrap-ellipsis mx-1" [class.f-gray]="activity.IsDone"
          [class.f-red]="!activity.IsDone && activity.IsOverdue" (click)="titleClick.emit(activity)"
          [class.pointer]="titleClick.observers.length"
          [title]="activity.Title || activity.Note || activity.ResultNote">
          <div *ngIf="compact" [innerHtml]="activity.Title || activity.Note || activity.ResultNote"></div>
          <ng-container *ngIf="!compact">{{activity.Title||'فعالیت'}}</ng-container>
        </div>
      </div>

      <div *ngIf="!compact">
        <div class="p-1 mt-1 x-light-gray-bg rounded-xl" *ngIf="activity.Note">
          <pre class="mb-0 overflow-auto" [innerHtml]="activity.Note" style="max-height: 200px;"></pre>
        </div>
        <div class="mr-4 mr-md-5 p-1 m-1 light-gray-bg rounded-xl" *ngIf="activity.ResultNote">
          <pre class="mb-0 overflow-auto" [innerHtml]="activity.ResultNote"
            style="max-height: 200px;"></pre>
        </div>

        <ng-container *ngIf="activity.Data" [ngTemplateOutlet]="dataTemplateRef"
          [ngTemplateOutletContext]="{$implicit:activity}"></ng-container>

      </div>
      <div class="d-flex align-items-center fs-xs">

        <div class="badge badge-light border p-0 fs-sm" [ngSwitch]="activity.Key">
          <div class="violet-bg f-white p-1" *ngSwitchCase="'seeker-call'"><i class="fa fa-user ml-1"></i>کارجو</div>
          <div class="violet-bg f-white p-1" *ngSwitchCase="'seeker-call-failed'"><i class="fa fa-user ml-1"></i>کارجو
          </div>
          <div class="service-bg f-white p-1" *ngSwitchCase="'job-call'"><i class="fa fa-building ml-1"></i>کارفرما
          </div>
          <div class="service-bg f-white p-1" *ngSwitchCase="'job-call-failed'"><i
              class="fa fa-building ml-1"></i>کارفرما</div>
        </div>

        <div class="mr-auto">{{activity.DoneDate || activity.DueDate || activity.CreateDate | pdate}}</div>
      </div>
      <div class="kp-toolbar kp-toolbar-hover">
        <i class="fa fa-ellipsis-v p-1 mr-1 f-gray pointer"></i>
        <div class="kp-toolbar-ext">
          <button class="btn btn-secondary btn-icon-circle ml-2" type="button"
            *ngIf="!activity.IsDone && activity.OperatorId==operator.Id" (click)="openDone(activity)"><i
              class="fa fa-check f-green fs-normal"></i></button>
          <button class="btn btn-secondary btn-icon-circle ml-2" type="button"
            *ngIf="operator.IsOperator || activity.CreatorId==operator.Id || (activity.IsDone && activity.OperatorId==operator.Id)"
            (click)="openEdit(activity)"><i class="fa fa-edit f-green fs-normal"></i></button>
        </div>
      </div>

    </div>
  </div>

</div>

<ngx-smart-modal customClass="" #activityModal identifier="activityModal">
  <activity-detail [activity]="selected" [type]="type" *ngIf="selected && activityModal.visible"
    (saved)="onUpdate($event)" [data]="data">
  </activity-detail>
</ngx-smart-modal>
